import { SITE_URL } from "./seoData";

export const SEO_IMAGES = {
  default: `${SITE_URL}/thiruvam_logo.png`,
  home: `${SITE_URL}/gallery-shrine-performers-group.jpeg`,
  wedding: `${SITE_URL}/gallery-shrine-performers-group.jpeg`,
  classes: `${SITE_URL}/gallery-training-session-march.jpeg`,
  courses: `${SITE_URL}/gallery-church-festival-group.jpeg`,
  melams: `${SITE_URL}/gallery-temple-shrine-group.jpeg`,
  programs: `${SITE_URL}/gallery-temple-shrine-group.jpeg`,
  fusions: `${SITE_URL}/praana-beats.jpg`,
  contact: `${SITE_URL}/gallery-shrine-performers-group.jpeg`,
  gallery: `${SITE_URL}/gallery-temple-shrine-group.jpeg`,
  testimonials: `${SITE_URL}/gallery-church-festival-group.jpeg`,
  instruments: `${SITE_URL}/gallery-morning-rehearsal.jpeg`,
  area: `${SITE_URL}/gallery-shrine-performers-group.jpeg`,
  city: `${SITE_URL}/gallery-shrine-performers-group.jpeg`,
};
